export default {
  // Navigation
  'nav.home': 'Hem',
  'nav.products': 'Produkter',
  'nav.cart': 'Varukorg',
  'nav.trackOrder': 'Spåra',
  'nav.contact': 'Kontakt',

  // Home Page
  'home.Välkommen Till': 'MUDO Online Butik',
  'home.MUDO Onlinebutik': 'Handgjord glass med kärlek sedan 1995',
  'home.hero.cta': 'Beställ Nu',
  'home.featured.title': 'Populära Smaker',
  'home.featured.viewAll': 'Se Alla Produkter',
  'home.categories.title': 'Kategorier',
  'home.about.title': 'Om Oss',
  'home.about.description': 'Vi har tillverkat handgjord glass i över 25 år. Våra recept är traditionella och våra ingredienser är alltid av högsta kvalitet. Varje glass görs med kärlek och omsorg.',
  'home.MUDO Academy': 'Redo att beställa?',
  'home.Building Future Heroes': 'Få din favoritglass levererad direkt till din dörr',
  'home.cta.button': 'Börja Handla',

  // Products Page
  'products.title': 'Våra Produkter',
  'products.all': 'Alla',
  'products.addToCart': 'Lägg till',
  'products.noProducts': 'Inga produkter hittades',

  // Product Detail
  'product.addToCart': 'Lägg till i Varukorg',
  'product.description': 'Beskrivning',
  'product.ingredients': 'Ingredienser',
  'product.selectSize': 'Välj Storlek',
  'product.quantity': 'Antal',

  // Cart
  'cart.title': 'Varukorg',
  'cart.empty': 'Din varukorg är tom',
  'cart.emptyDesc': 'Lägg till produkter för att börja handla',
  'cart.startShopping': 'Börja Handla',
  'cart.continueShopping': 'Fortsätt Handla',
  'cart.size': 'Storlek',
  'cart.flavor': 'Smak',
  'cart.orderSummary': 'Ordersammanfattning',
  'cart.subtotal': 'Delsumma',
  'cart.total': 'Totalt belopp inkl. moms.',
  'cart.taxIncluded': 'Moms ingår i priset',
  'cart.proceedToCheckout': 'Gå till kassan',
  'cart.checkout': 'Till Kassan',
  'cart.remove': 'Ta bort',

  // Checkout
  'checkout.title': 'Kassa',
  'checkout.contactInfo': 'Kontaktinformation',
  'checkout.name': 'Namn',
  'checkout.email': 'E-post',
  'checkout.phone': 'Telefon',
  'checkout.orderSummary': 'Ordersammanfattning',
  'checkout.total': 'Totalt belopp inkl. moms.',
  'checkout.placeOrder': 'Slutför Beställning',
  'checkout.processing': 'Bearbetar...',

  // Track Order
  'trackOrder.title': 'Spåra Beställning',
  'trackOrder.subtitle': 'Ange ditt ordernummer och e-post för att spåra din beställning',
  'trackOrder.orderNumber': 'Ordernummer',
  'trackOrder.orderNumberPlaceholder': 'T.ex. ORD-12345',
  'trackOrder.email': 'E-post',
  'trackOrder.emailPlaceholder': 'din@email.com',
  'trackOrder.trackButton': 'Spåra Beställning',
  'trackOrder.searching': 'Söker...',
  'trackOrder.notFound': 'Beställning hittades inte. Kontrollera ditt ordernummer och e-post.',
  'trackOrder.error': 'Ett fel uppstod. Försök igen senare.',
  'trackOrder.orderStatus': 'Beställningsstatus',
  'trackOrder.orderDate': 'Beställningsdatum',
  'trackOrder.totalAmount': 'Totalt belopp inkl. moms. Belopp',
  'trackOrder.customerInfo': 'Kundinformation',
  'trackOrder.name': 'Namn',
  'trackOrder.phone': 'Telefon',
  'trackOrder.orderItems': 'Beställda Produkter',
  'trackOrder.size': 'Storlek',
  'trackOrder.quantity': 'Antal',

  // Contact
  'contact.title': 'Kontakta Oss',
  'contact.subtitle': 'Vi hjälper dig gärna!',
  'contact.name': 'Namn',
  'contact.email': 'E-post',
  'contact.message': 'Meddelande',
  'contact.send': 'Skicka Meddelande',
  'contact.sending': 'Skickar...',
  'contact.success': 'Tack! Vi återkommer snart.',
  'contact.error': 'Något gick fel. Försök igen.',
  'contact.info.title': 'Kontaktinformation',
  'contact.info.address': 'Adress',
  'contact.info.phone': 'Telefon',
  'contact.info.email': 'E-post',
  'contact.info.hours': 'Öppettider',
  'contact.info.hoursValue': 'Mån-Fre: 10:00-18:00',

  // Common
  'common.loading': 'Laddar...',
  'common.error': 'Ett fel uppstod',
  'common.success': 'Lyckades!',
  'common.cancel': 'Avbryt',
  'common.confirm': 'Bekräfta',
  'common.close': 'Stäng',
  'common.save': 'Spara',
  'common.delete': 'Ta bort',
  'common.edit': 'Redigera',
  'common.back': 'Tillbaka',
  'common.next': 'Nästa',
  'common.previous': 'Föregående',
  'common.search': 'Sök',
  'common.filter': 'Filtrera',
  'common.sort': 'Sortera',
  'common.viewMore': 'Visa Mer',
  'common.viewLess': 'Visa Mindre',
};